
import { convertDateTimeToUTC, datetimeFormat } from '../helpers';

import { transformedMedia } from './mediaLibrary';

import {
	PERIOD_STATUS_LABELS,
	PERIOD_STATUS_COLOR,
} from '../../../enums/status';

// From Api section
export const transformedBannerInSearchCategory = (category = {}) => {
	return {
		id: category.id || null,
		name: category.name || '',
	};
};

export const transformedBannerInSearchMedia = (media = {}) => {
	return {
		desktopBannerTh: media.desktop ? transformedMedia(media.desktop) : null,
		desktopBannerEn: media.desktop_en ? transformedMedia(media.desktop_en) : null,
		mobileBannerTh: media.mobile ? transformedMedia(media.mobile) : null,
		mobileBannerEn: media.mobile_en ? transformedMedia(media.mobile_en) : null,
	};
};

export const transformedBannerInSearchDetail = (detail = {}) => {
	const item = detail.item || {};
	const categories = detail.categories
		? detail.categories.map((category) => transformedBannerInSearchCategory(category))
		: [];
	return {
		id: detail.id || null,
		name: detail.name || '',
		isActive: detail.is_active ? 1 : 0,
		startDate: new Date(datetimeFormat(detail.start_at)),
		startTime: datetimeFormat(detail.start_at, 'HH:mm'),
		endDate: new Date(datetimeFormat(detail.end_at)),
		endTime: datetimeFormat(detail.end_at, 'HH:mm'),
		link: item.custom_url || '',
		categories: categories.filter((category) => category.id !== null),
		media: item.media ? transformedBannerInSearchMedia(item.media) : {},
	};
};

export const transformedBannerInSearch = (item = {}) => {
	return {
		id: item.id || null,
		name: item.name || '',
		isActive: item.is_active || false,
		previewPeriod: {
			label: PERIOD_STATUS_LABELS[item.period] || '',
			color: PERIOD_STATUS_COLOR[item.period] || '',
		},
		period: item.period || '',
		previewStartAt: item.start_at ? datetimeFormat(item.start_at) : null,
		previewEndAt: item.end_at ? datetimeFormat(item.end_at) : null,
		startAt: item.start_at,
		endAt: item.end_at,
	};
};

export const transformedBannerInSearchList = (items = []) => {
	return items.map(transformedBannerInSearch);
};
// End From Api section

// To Api section
export const transformedMediaToApi = (media = {}) => {
	return {
		desktop_file_id: media.desktopBannerTh?.id || null,
		desktop_en_file_id: media.desktopBannerEn?.id || null,
		mobile_file_id: media.mobileBannerTh?.id || null,
		mobile_en_file_id: media.mobileBannerEn?.id || null,
	};
};

export const transformedItemToApi = (item = {}) => {
	const media = item.media || {};
	return {
		is_visible: true,
		custom_url: item.link || '',
		media: transformedMediaToApi(media),
	};
};

export const transformedBannerInSearchToApi = (banner = {}) => {
	return {
		name: banner.name || '',
		priority: Number(banner.priority) || 0,
		is_active: Boolean(banner.isActive),
		start_at: convertDateTimeToUTC(banner.startDate, banner.startTime),
		end_at: convertDateTimeToUTC(banner.endDate, banner.endTime),
		category_ids: banner.categories?.map((category) => category.id) || [],
		item: transformedItemToApi(banner),
	};
};
// End To Api section